import * as React from "react";

import RefreshIcon from "@mui/icons-material/Refresh";
import InputAdornment from "@mui/material/InputAdornment";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import {
  UseFormRegister,
  FormState,
  UseFormSetValue,
  UseFormSetError,
  UseFormClearErrors,
} from "react-hook-form/dist/types";

import FetchIP from "src/common/hooks/FetchIP";
import { CreateFormInput } from "src/domain/core/workflow/components/create/LaunchWorkflowForm";
import { ipClient } from "src/lib/ipClient";

const Row = styled("div")(() => ({
  marginBottom: "30px",
  display: "flex",
  justifyContent: "space-between",
}));

interface IPInputProps {
  register: UseFormRegister<CreateFormInput>;
  formState: FormState<CreateFormInput>;
  setValue: UseFormSetValue<CreateFormInput>;
  setError: UseFormSetError<CreateFormInput>;
  clearErrors: UseFormClearErrors<CreateFormInput>;
}

export const IPInput: React.FC<IPInputProps> = ({ register, formState, setValue, setError, clearErrors }) => {
  const fetchIP = FetchIP(ipClient, setValue, setError);

  React.useEffect(() => {
    // This is an intentional design decision to bake the IP address fetching into the
    // workflow config form. This could have been a dependency in an effort to follow
    // the dependency inversion principle, but since the automatic fetching and support
    // for refreshing IP address is an integral part of this form it was decided that
    // this might be the best place for it. Future requirements, might prove otherwise.
    fetchIP();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Row>
      <TextField
        fullWidth
        id="access-from"
        inputProps={{
          "data-testid": "access-from",
        }}
        defaultValue=""
        {...register("access_from")}
        helperText={
          formState.errors?.access_from?.message ||
          "The IP address from which your workflow can be accessed. Click the circular arrow to auto-populate with your public IP address, or set to 0.0.0.0/0 to remove IP access restrictions."
        }
        error={formState.errors?.access_from && true}
        InputProps={{
          endAdornment: (
            <div
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                clearErrors("access_from");
                fetchIP();
              }}
            >
              <InputAdornment position="start">
                <RefreshIcon />
              </InputAdornment>
            </div>
          ),
        }}
      />
    </Row>
  );
};
